<template>
  <section class="sidebar px-3 d-flex flex-column justify-content-between">
    <div class="text-left ps-4 pt-5 pb-4">
      <img
        alt="ted logo"
        class="img-fluid logo-img"
        :src="require(`@/assets/images/sidebar/${tenantType}-logo.svg`)"
      />
    </div>

    <div
      v-for="(section, index) in sidebarContent"
      :key="index + 'sidebar-section'"
    >
      <ul class="list-unstyled">
        <li
          v-for="(element, index) in section.sections"
          :key="index"
          :class="element.class"
          @click="element.text == 'logout' ? logout() : ''"
        >
          <router-link
            :to="{ name: element.link }"
            class="px-4 mx-2 pb-2 d-flex gap-3"
          >
            <div class="text-center list-icons-container pr-4">
              <img
                :src="require(`@/assets/images/sidebar/${element.img}.svg`)"
                :alt="element.alt"
                class="img-fluid list-icons"
                width="48"
              />
            </div>
            <div class="my-auto">
              <span class="text-capitalize text" v-html="element.text"></span>
            </div>
          </router-link>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
export default {
  name: "Sidebar",
  data() {
    return {
      sidebarContent: [
        {
          sections: [
            {
              text: "Dashboard",
              img: "live_board",
              class: "Board",
              alt: "Live Monitoring Board",
              link: "Dashboard",
            },
            // {
            //   text: "Organization",
            //   img: "organization",
            //   class: "organization",
            //   alt: "organization",
            // },
            // {
            //   text: "Surveys",
            //   img: "list",
            //   class: "surveys",
            //   alt: "surveys list",
            // },
            // {
            //   text: "KPIs",
            //   img: "star",
            //   class: "overview",
            //   alt: "star",
            // },
          ],
        },
        {
          sections: [
            // {
            //   text: "Support",
            //   img: "support",
            //   class: "support",
            //   alt: "help",
            // },
            // {
            //   text: "Settings",
            //   img: "settings",
            //   class: "setting",
            //   alt: "Settings",
            // },
          ],
        },
        {
          sections: [
            {
              text: "switch Platform",
              img: "menu-switch",
              class: "switch",
              alt: "switch",
              link: "Select",
            },
            {
              text: "logout",
              img: "logout",
              class: "logout",
              alt: "logout",
            },
          ],
        },
      ],
    };
  },
  computed: {
    tenantType() {
      return this.$store.getters["auth/tenantType"].toLowerCase();
    },
  },
  methods: {
    logout() {
      this.$store.dispatch("auth/logout");
    },
  },
};
</script>

<style lang="scss" scoped>
.sidebar {
  top: 0;
  height: 100%;
  overflow-x: hidden;

  &:hover {
    .text {
      opacity: 1;
      visibility: visible;
    }
  }
}
.line {
  display: block;
  margin: 1rem auto;
  background-color: $color-grey-60;
}

.text {
  color: $color-white;
  text-decoration: none;
  display: block;
  width: max-content;
  opacity: 0;
  visibility: hidden;
  transition: $transition-300ms;
  font-style: normal;
  font-weight: $font-weight-semiBold;
  font-size: 1rem;
  line-height: 1.3rem;
}
.list-icons-container {
  width: 3.125rem;
  min-width: 3.125rem;
}

.logo-img {
  width: 6rem;
}

@media (max-width: $breakpoint-xl) {
  .select-images {
    p {
      margin-bottom: 0.5rem;
    }
    img {
      width: 60%;
    }
  }
}
</style>
